// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-max-portable-power-station_productcontent__KVza0"};